import { ApiChartTemplate, ApiChartType } from "@incendium/api";
import { Box } from "@mui/material";
import { useSelectedProject } from "Hooks";
import { useReportBuilderContext } from "Providers/ReportBuilderProvider";
import { useCallback, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLayoutContext } from "Providers/LayoutProvider";
import { ChartLibraryList } from "features/chartLibrary";
import { IChart } from "Interfaces";
import { useCharts } from "Hooks/useCharts";
import { friendlyDateTime } from "Helpers/dates";

function ChartLibraryPage() {
  const { setPageTitle } = useLayoutContext();
  const history = useHistory();
  const { setChart } = useReportBuilderContext();
  const { saveNewChart } = useCharts();

  const { selectedProject, selectedClient } = useSelectedProject();

  useLayoutEffect(() => {
    setPageTitle("Chart Library");
    return () => {
      setPageTitle("");
    };
  }, [setPageTitle]);

  const onNewChart = useCallback(async () => {
    const res = await saveNewChart(
      {
        name: `Chart (${friendlyDateTime(new Date())})`,
        type: ApiChartType.TABLE,
        template: ApiChartTemplate.TABLE,
        yAxisKeys: [],
        dimension: [],
        attributes: [],
        orderBy: "",
      },
      selectedProject,
    );

    setChart(res);
    history.push(
      `/clients/${selectedClient?.id}/projects/${selectedProject?.id}/analyse/reports/chart-library/${res.id}`,
    );
  }, [setChart, saveNewChart, selectedProject, history, selectedClient]);

  const onEdit = useCallback(
    (chart: IChart) => {
      history.push(
        `/clients/${selectedClient?.id}/projects/${selectedProject?.id}/analyse/reports/chart-library/${chart.id}`,
      );
    },
    [history, selectedClient, selectedProject],
  );

  return (
    <>
      <Box mb={2}>
        <ChartLibraryList onClick={onEdit} onCreate={onNewChart} />
      </Box>
    </>
  );
}

export default ChartLibraryPage;
